import fetch from 'unfetch'
import {trimStart, trimEnd, Dictionary} from 'lodash'
import useSWR from 'swr'
import {fetcherFn} from 'swr/dist/types'

import config from '../config'
import {useAuth} from '../contexts/UserContext'

const baseUrl = trimEnd(config.restApi.url, '/')

async function handleResponse(res: fetch.IsomorphicResponse) {
  const data = await res.json()

  if (res.status >= 400) {
    if (data.detail) {
      throw new Error(data.detail)
    }
    throw new Error(data)
  }

  return data
}

function _request(method: string, url: string, authToken?: string, props?: Dictionary<string>) {
  return fetch(`${baseUrl}/${trimStart(url, '/')}`, {
    method,
    headers: authToken ? {
      'Content-Type': 'application/json',
      Authorization: `JWT ${authToken}`
    } : undefined,
    ...props,
  }).then(handleResponse)
}

export function get(url: string, authToken?: string) {
  return _request('GET', url, authToken)
}

export function post(url: string, authToken?: string, data?: any) {
  return _request('POST', url, authToken, {
    body: JSON.stringify(data),
  })
}

export function patch(url: string, authToken?: string, data?: any) {
  return _request('PATCH', url, authToken, {
    body: JSON.stringify(data),
  })
}

export const fetcher = {
  get,
  post,
  patch,
}

export function useApi<Data = any>(url: string, fetcher?: fetcherFn<Data>) {
  const {authToken} = useAuth()
  return useSWR<Data>([url, authToken], fetcher || get, {revalidateOnFocus: false})
}
